import { createFileRoute } from "@tanstack/react-router";

import { AGENT_ROLES, AuthGuard } from "@/lib/auth";
import { NotificationBannersPage } from "@/features/notification-banners/admin/pages/notification-banners-page";

export const Route = createFileRoute(
	"/_authenticated/admin/notification-banners/"
)({
	component: NotificationBannersRouteComponent,
});

// The `admin` layout guard only requires support_admin; a banner reaches every
// agent's screen, so the proxy's writes are admin-only and so is this page.
function NotificationBannersRouteComponent() {
	return (
		<AuthGuard requiredRole={AGENT_ROLES.ADMIN}>
			<NotificationBannersPage />
		</AuthGuard>
	);
}
